export const RoleType = {
  ALERT: 'alert',
  BUTTON: 'button',
  PRESENTATION: 'presentation',
  IMAGE: 'img',
};
